<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .col-12.mb-2
        h3.section-title.mt-0 {{ rrcName }}
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="sessionStatus" @change="getRewardRainSessionList(true)" :disabled="loading" size="sm")
            option(:value="null") {{ $t('ui.all') }}
            option(v-for="info in statusList" :value="info.status") {{ info.description }}
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getRewardRainSessionList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-6.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addRewardRainSession type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_reward_rain_session") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="9%" @click="sortOrder('rrc_name')")
                  span(:title="$t('ui.name')") {{ $t("ui.name") }}
                  .float-right
                    i(:class="changeSortKey('rrc_name')")
                th(width="8%")
                  span(:title="$t('ui.campaign_id')") {{ $t("ui.campaign_id") }}
                th.text-right(width="9%")
                  span(:title="$t('ui.min_amount')") {{ $t('ui.short.min_amount') }}
                  br
                  span(:title="$t('ui.max_amount')") {{ $t('ui.short.max_amount') }}
                th.text-right(width="9%")
                  span(:title="$t('ui.reward_count')") {{ $t('ui.reward_count') }}
                  br
                  span(:title="$t('ui.claimed_count')") {{ $t('ui.claimed_count') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-right(width="11%")
                  span(:title="$t('ui.total_claimed_amount')") {{ $t("ui.short.total_claimed_amount") }}
                th.text-right(width="8%" @click="sortOrder('start_at')")
                  span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                  .float-right
                    i(:class="changeSortKey('start_at')")
                th.text-right(width="8%" @click="sortOrder('end_at')")
                  span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                  .float-right
                    i(:class="changeSortKey('end_at')")
                th.text-center(width="8%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="8%" @click="sortOrder('created_at')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  .float-right
                    i(:class="changeSortKey('created_at')")
                th.text-right(width="9%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="rewardRainSessionList.length == 0")
                td(colspan="12").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in rewardRainSessionList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.rrs_name")
                    b-link.text-decoration-none(href="javascript:void(0);" @click="$emit('clicked', item.id, item.rrs_name, 2)") {{ item.rrs_name }}
                td
                  span(:title="item.campaign_id") {{ item.campaign_id }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.min_amount)" :title="$n(item.min_amount, 'currency')") {{ $n(item.min_amount, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(item.max_amount)" :title="$n(item.max_amount, 'currency')") {{ $n(item.max_amount, 'currency') }}
                td.text-right
                  span(:title="item.reward_count") {{ item.reward_count }}
                  br
                  span(:title="item.claimed_count") {{ item.claimed_count }}
                td.text-center
                  span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.total_claimed_amount)" :title="$n(item.total_claimed_amount, 'currency')") {{ $n(item.total_claimed_amount, 'currency') }}
                td.text-right
                  span(:title="$moment(item.start_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.start_at).format('YYYY-MM-DD') }}
                  br
                  span(:title="$moment(item.start_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.start_at).format('HH:mm:ss') }}
                td.text-right
                  template(v-if="isEditAccess")
                    a.text-primary.font-weight-bold.text-decoration-none(href="javascript:void(0)" @click="onUpdateEndDate(item)")
                      span(:title="$moment(item.end_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.end_at).format("YYYY-MM-DD") }}
                      br
                      span(:title="$moment(item.end_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.end_at).format("HH:mm:ss") }}
                  template(v-else)
                    span(:title="$moment(item.end_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.end_at).format("YYYY-MM-DD") }}
                    br
                    span(:title="$moment(item.end_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.end_at).format("HH:mm:ss") }}
                td.text-center(v-if="isEditAccess")
                  span.mr-2(v-if="mapStatusId(item.status) == 0")
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                      href="javascript:void(0)"
                      @click="onEdit(item)"
                      :title="$t('ui.edit')"
                      )
                  span(v-if="mapStatusId(item.status) == 0 || mapStatusId(item.status) == 2")
                    a.fa.fa-ban.btn.btn-ssm.btn-icon.btn-danger(
                      href="javascript:void(0)"
                      @click="cancelSession(item)"
                      :title="$t('ui.cancel')"
                      )
                td.text-right
                  span.d-block(:title="item.created_by") {{ item.created_by }}
                  span(v-if="item.created_at" :title="$moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_at).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span.d-block(:title="item.modified_by") {{ item.modified_by }}
                  span(v-if="item.modified_at" :title="$moment(item.modified_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_at).format('YYYY-MM-DD, HH:mm:ss') }}
              tr(v-if="showTotal")
                td.text-right(colspan="6")
                  span.d-block {{ $t("ui.sub_total") }}
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
                td
                td
                td
                td
                td(v-if="isEditAccess")

    addrewardrainsession(@clicked="addRewardRainSession" :operatorID="operatorID" :rrcId="rrcId" @failed="handleFailed")
    editrewardrainsession(ref="editrewardrainsession" :operatorID="operatorID" :item="editSelectedRrs" @clicked="afterEdit" @failed="handleFailed")
    editrewardrainsessionenddate(ref="editrewardrainsessionenddate" :item="editSelectedRrs" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addrewardrainsession from "@/components/rewardTab/addRewardRainSession.vue";
import editrewardrainsession from "@/components/rewardTab/editRewardRainSession.vue";
import editrewardrainsessionenddate from "@/components/rewardTab/editRewardRainSessionEndDate.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addrewardrainsession,
    editrewardrainsession,
    editrewardrainsessionenddate
  },
  props: {
    rrcId: {
      type: Number,
      default: ''
    },
    rrcName: {
      type: String,
      default: ""
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    loading: false,
    rewardRainSessionList: [],
    statusList: [],
    sortKey: "",
    sortType: "",
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sessionStatus: null,
    editSelectedRrs: null,
    subTotalAmount: 0,
    grandTotalAmount: 0,
    showTotal: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeRewardRain;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_rewardrain");
    }
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.getRewardRainSessionStatusLookup();
      this.getRewardRainSessionList(true)
    },
    // redirect(mode) {
    //   this.mode = mode
    //   this.getList(true);
    // },
    // pageMode(domainName, e) {
    //   // this.selectedOperatorID = this.searchID
    //   this.mode = e
    //   this.selectedDomainName = domainName
    //   var vm = this
    //   $(document).ready(function(){
    //     // vm.$refs.voucherRedeemedDetail.getList()
    //   });
    // },
    mapStatusId(statusDesc) {
      const obj = this.statusList.find(item => item.description === statusDesc);
      if(obj != null) return obj.status

      return null
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getRewardRainSessionList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    addRewardRainSession: function() {
      this.sessionStatus = null;
      this.getRewardRainSessionList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_reward_rain_session"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedRrs = e;
      this.$refs.editrewardrainsession.$refs.editRewardRainSession.show();
    },
    afterEdit() {
      this.getRewardRainSessionList(true);
      this.$helpers.showDialog(this.$t("ui.combine.edit_reward_rain"), this.$t("message.success"), "success");
    },
    onUpdateEndDate(e) {
      this.editSelectedRrs = e;
      this.$refs.editrewardrainsessionenddate.$refs.editRewardRainSessionEndDate.show();
    },
    getRewardRainSessionList: function(isSearch) {
      let url = config.rewardRainSessionListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        rrc_id: this.rrcId,
        session_status: this.sessionStatus,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearTotal()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.list && response.data.ds.list.length > 0) {
                  this.showTotal = true
                  this.rewardRainSessionList = response.data.ds.list;
                  this.totalRow = this.rewardRainSessionList.length > 0 ? this.rewardRainSessionList[0].totalrows : 0;

                  response.data.ds.list.forEach(value => {
                    this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["total_claimed_amount"]);
                  });
                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalAmount = response.data.ds.grand_total[0]["total_claimed_amount"];
                  }
                } else {
                  this.clearTotal()
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRewardRainSessionStatusLookup: function() {
      let url = config.rewardRainSessionStatusLookupUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.statusList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false
      this.rewardRainSessionList = []
      this.totalRow = 0
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    cancelSession: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.cancel_reward_rain_session_confirm", { name: item.rrs_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmCancel(item);
          }
        });
    },
    confirmCancel: function(item) {
      let url = config.rewardRainSessionCancelUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        session_id: item.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getRewardRainSessionList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getRewardRainCampaignList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeRewardRain", pageSize);
      this.currentPage = 1;
      this.getRewardRainSessionList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRewardRainSessionList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>